<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("relatorio-lancamentos") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("despesas")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("relatorios")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("relatorio-lancamentos")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div class="search-and-filter">
                    <div class="columns is-variables is-desktop">
                        <div class="column header-search is-4">
                            <search-bar
                                :clean="limparBusca"
                                :onSearch="debouncedOnSearch"
                                :placeholder="$t('busca')"
                                width="40"
                                tooltipLabel="msg-campo-busca-acertos"
                            />
                        </div>
                        <!-- Data Inicio-->
                        <div class="column is-3">
                            <verified-date-picker
                                dateType="startDate"
                                v-model="datainicial"
                                :endDate="datafinal"
                                title="data-inicio"
                                @input="changeStartDate"
                            />
                        </div>
                        <!-- Data Fim-->
                        <div class="column is-3">
                            <verified-date-picker
                                dateType="endDate"
                                v-model="datafinal"
                                :startDate="datainicial"
                                title="data-fim"
                                @input="changeEndDate"
                            />
                        </div>

                        <div class="column is-2">
                            <div class="is-mobile mt-2-custom">
                                <b-button
                                    class="float-right"
                                    type="is-primary"
                                    icon-right="file-pdf"
                                    @click="getReportPDF()"
                                    v-tippy 
                                    :title="$t('msg-tooltip-pdf')"
                                />

                                <b-button
                                    class="mr-2 float-right"
                                    type="is-primary"
                                    icon-right="google-spreadsheet"
                                    @click="getReportCSV()"
                                    v-tippy 
                                    :title="$t('msg-tooltip-csv')"
                                />

                                <b-button
                                    class="mr-2 float-right"
                                    type="is-primary"
                                    icon-right="filter"
                                    @click="showFiltros = !showFiltros"
                                    v-tippy 
                                    :title="$t('filtros')"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <section class="registry-wrapper mt-4">
                    <container-loader
                        v-if="isLoading && !$store.getters.isLoading"
                    />
                    <empty-table-message class="mt-3" v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="adiantamentos"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <template v-for="f in fields">
                            <b-table-column
                                :key="f.key + '-' + f.colaborador"
                                :field="f.key"
                                :label="f.key == 'deletar' ? '' : f.key"
                                :class="{ 'excluir-field': f.key == 'deletar' }"
                                :width="f.width"
                                :sortable="f.sortable"
                            >
                                <!-- Cabeçalho da listagem -->
                                <template v-slot:header="{ column }">
                                    <span v-if="column.label == 'despesas'">
                                        {{ $t("despesas") }}
                                        <div class="table-sep" />
                                        {{ $t("prestacao-contas") }}
                                    </span>
                                    <span v-else>
                                        {{ column.label ? $t(column.label) : "" }}
                                    </span>
                                </template>
                                <!-- Dados da listagem -->
                                <template v-slot="props">
                                    <div
                                        class="has-text-left"
                                        v-if="f.key == 'colaborador'"
                                    >
                                        {{ props.row.colaborador }}
                                    </div>
    
                                    <div v-else-if="f.key == 'despesas'" >
                                        <span v-if="props.row['isDespesa']">
                                            {{ props.row['descricao'] }}
                                        </span>
                                        <span v-else>---</span>
                                        <div class="table-sep" />
                                        <span v-if="!props.row['isDespesa']">
                                            {{ props.row['descricao'] }}
                                        </span>
                                        <span v-else>---</span>
                                    </div>
    
                                    <div v-else-if="f.key == 'motivo'">
                                        <a @click="showLancamento(props.row.iddespesa, props.row.isDespesa)">
                                            {{ props.row["motivo"] }}
                                        </a>
                                    </div>
    
                                    <div v-else-if="f.key == 'valor'">
                                        {{ getDecimal(props.row.valor, null, true) }}
                                    </div>
    
                                    <div v-else-if="f.key == 'data-lancamento'">
                                        <span v-if="props.row['data-lancamento']">
                                            {{
                                                props.row["data-lancamento"]
                                                    | moment("L")
                                            }}
                                        </span>
                                    </div>
    
                                    <div v-else-if="f.key == 'situacao'">
                                        <b-tag
                                            class="table-tag table-tag-full-width"
                                            :type="
                                                isStatusButtonType(props.row.situacao)
                                            "
                                            size="is-medium"
                                        >
                                            {{
                                                $t(
                                                    props.row.situacao.toLowerCase()
                                                )
                                            }}
                                        </b-tag>
                                    </div>
                                </template>
                            </b-table-column>
                        </template>
                        <template slot="footer">
                            <th
                                v-for="f in fields"
                                :key="f.key + '-' + f.nome"
                                :id="f.key"
                            >
                                <span v-if="f.key == 'nome'"
                                    >{{ acertos.length }}
                                    {{ $t("registro") }}</span
                                >
                                <span v-if="f.key == 'valor'">
                                    {{ getDecimal(valorAdiantamentos, null, true) }}
                                </span>
                                <span v-else></span>
                            </th>
                        </template>
                    </b-table>
                </section>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>

        <FiltroLateral
            :isLoading="isLoading"
            :showFilter="showFiltros"
            :filterCompact="false"
            @closeFilter="showFiltros = !showFiltros"
            @onClearFilters="onCleanFilters"
            @searchTable="timeoutCarregarDados"
        >
            <div class="card-content">
                <div class="columns is-multiline card-content-section">
                    <div class="column is-6 is-full-mobile card-content-top">
                        <vss-select
                            title="area"
                            placeholder="selecione"
                            v-model="areaSelected"
                            :options="areaSelect"
                            @input="changeSituacao"
                            mlLabels
                        />
                    </div>
                    <div class="column is-6 is-full-mobile card-content-top">
                        <label v-text="$t('situacao')" />
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy 
                            :title="$t('msg-campo-area-situacao')"
                        />
                        <vss-select
                            v-model="situacaoSelected"
                            :options="situacaoSelect"
                            mlLabels
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-6 is-full-mobile card-content-top">
                        <vss-select
                            title="empresa"
                            label="label"
                            :options="empresaSelect"
                            v-model="empresaSelected"
                            :loading="empresaLoading"
                            @search="filtroEmpresas"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-6 is-full-mobile card-content-top">
                        <vss-select
                            title="colaborador"
                            label="label"
                            :options="colaboradorSelect"
                            v-model="colaboradorSelected"
                            :loading="colaboradorLoading"
                            @search="filtroColaboradores"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                    <div class="column is-6 is-full-mobile card-content-motivo">
                        <vss-select
                            title="motivo"
                            label="label"
                            :options="motivoDespesaSelect"
                            v-model="motivoDespesaSelected"
                            :loading="motivoDespesaLoading"
                            @search="filtroMotivoDespesas"
                            multiple
                            searchable
                            clearable
                            :closeOnSelect="false"
                        />
                    </div>
                </div>
            </div>
        </FiltroLateral>

        <!-- 
            @70209 - Modal para ver destalhes do lançamento
        -->
        <b-modal :active.sync="isShowingLancamento">
            <div class="bg p-3">
                <LancamentosViewModal 
                    :id="idLancamento"
                    :isDespesa="isDespesa"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import RelatorioLancamentosService from "@/services/despesas/RelatorioLancamentosService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import Message from "@/models/Message";
import LancamentosViewModal from "./LancamentosViewModal.vue";
import FiltroLateral from "@/components/shared/FiltroLateral";

export default {
    components: {
        ContainerLoader,
        LancamentosViewModal,
        FiltroLateral,
    },
    data() {
        return {
            situacaoSelected: [],
            situacaoSelect: [],

            areaSelected: { label: "todos", id: -1 },
            areaSelect: [
                { label: "todos", id: -1 },
                { label: "prestacao-contas", id: 0 },
                { label: "despesas", id: 1 },
            ],

            empresaSelected: [],
            empresaSelect: [],
            empresaLoading: false,

            colaboradorSelected: [],
            colaboradorSelect: [],
            colaboradorLoading: false,

            motivoDespesaSelected: [],
            motivoDespesaSelect: [],
            motivoDespesaLoading: false,

            datainicial: (() => {
                let trintaDiasAtras = new Date();
                trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 31);
                return trintaDiasAtras;
            })(),
            datafinal: new Date(),

            fields: [
                {
                    key: "despesas",
                    width: null,
                    sortable: false,
                    label: "despesas",
                    footer: true,
                },
                {
                    key: "motivo",
                    width: null,
                    sortable: true,
                    label: "motivo",
                    footer: true,
                },
                {
                    key: "colaborador",
                    width: null,
                    sortable: true,
                    label: "colaborador",
                    footer: true,
                },
                {
                    key: "valor",
                    width: null,
                    sortable: true,
                    label: "valor",
                    footer: true,
                },
                {
                    key: "data-lancamento",
                    width: null,
                    sortable: true,
                    label: "data-lancamento",
                    footer: false,
                },
                {
                    key: "situacao",
                    width: 100,
                    sortable: true,
                    label: "situacao",
                    footer: false,
                },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            msgs: [],
            adiantamentos: [],
            service: new RelatorioLancamentosService(this.$http, this.$router),
            debouncedOnSearch: Function,
            filtros: {
                search: "",
                datainicial: null,
                datafinal: null,
                sort: "datahora",
                order: "desc",
                situacao: [],
                area: [],
                empresa: [],
                usuario: [],
                motivo: [],
            },
            limparBusca: false,
            showFiltros: false,
            isLoading: true,
            isEmpty: false,
            valorAdiantamentos: 0,
            delete: null,
            permissao: {},
            firstTime: true,
            isExporting: false,
            noData: false,
            isShowingLancamento: false,
            idLancamento: 0,
            isDespesa: false,
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "relatorios",
            "des-relatorio-lancamentos"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "relatorio-lancamentos" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados(1);
            this.filtroEmpresas();
            this.filtroMotivoDespesas();
            this.filtroColaboradores();
        }
    },
    methods: {
        atualizaFiltros() {
            this.filtros.datainicial = this.datainicial
                ? this.$moment(this.datainicial).format("YYYY-MM-DD")
                : null;

            this.filtros.datafinal = this.datafinal
                ? this.$moment(this.datafinal)
                        .add(1, "days")
                        .format("YYYY-MM-DD")
                : null;

            this.filtros.area = this.areaSelected ? this.areaSelected.id : null;

            this.filtros.situacao = this.situacaoSelected.length == 0 
                    ? [] : this.situacaoSelected.map(e => e.id)

            this.filtros.empresa = this.empresaSelected.length == 0 
                    ? [] : this.empresaSelected.map(e => e.id)

            this.filtros.usuario = this.colaboradorSelected.length == 0 
                    ? [] : this.colaboradorSelected.map(e => e.id)

            this.filtros.motivo = this.motivoDespesaSelected.length == 0 
                    ? [] : this.motivoDespesaSelected.map(e => e.id)
        },
        getReportPDF() {
            this.isLoading = true;

            this.atualizaFiltros();

            this.service
                .findAllExport(this.filtros)
                .then((value) => {
                    let filename =
                        "Lançamentos-" +
                        this.$moment().format("DD-MM-YYYY_HH-mm-ss") +
                        ".pdf";
                    let blob = new Blob([value], { type: "application/pdf" });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", filename);
                    link.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(blob);
                    }, 100);
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error(e);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        getReportCSV() {
            if (!this.isExporting) {
                this.isExporting = true;
                this.isLoading = true;
                if (this.firstTime) this.firstTime = false;
                this.service
                    .getCSVReport(this.filtros)
                    .then(this.downloadCSV)
                    .catch((e) => {
                        console.error("Erro ao trazer dados para o csv.", e);
                        this.showMessage("error", "msg-erro-relatorio");
                        this.noData = true;
                    })
                    .finally(() => {
                        this.isExporting = false;
                        this.isLoading = false;
                    });
            }
        },
        downloadCSV(csv) {
            let filename, link, blob, url;
            if (csv == null) return;
            blob = new Blob(["\ufeff", csv], {
                encoding: "UTF-8",
                type: "data:text/csv;charset=utf-8;",
            });
            url = URL.createObjectURL(blob);
            filename =
                "Lançamentos-" +
                this.$moment().format("DD-MM-YYYY_HH-mm-ss") +
                ".csv";
            link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        filtroEmpresas(search = '') {
            this.empresaLoading = true;
            this.service
                .filtroEmpresas(search)
                .then((body) => {
                    if (body.content != null) {
                        this.empresaSelect = body.content.map((m) => {
                            return {
                                id: m.empresa.idempresa,
                                label: m.empresa.nome,
                            };
                        });
                    } else {
                        return null;
                    }
                })
                .catch(console.error)
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        filtroColaboradores(search = '') {
            this.colaboradorLoading = true;
            this.service
                .filtroColaboradores(search)
                .then((body) => {
                    if (body.content != null) {
                        this.colaboradorSelect = body.content.map((m) => {
                            return {
                                id: m.usuario.idusuario,
                                label: m.usuario.nome,
                            };
                        });
                    } else {
                        return null;
                    }
                })
                .catch(console.error)
                .finally((_) => {
                    this.colaboradorLoading = false;
                });
        },
        filtroMotivoDespesas(search = '') {
            this.motivoDespesaLoading = true;
            this.service
                .filtroMotivoDespesas(search)
                .then((body) => {
                    if (body.content != null) {
                        this.motivoDespesaSelect = body.content.map((m) => {
                            return { 
                                id: m.iddespesamotivo, 
                                label: m.descricaomotivo 
                            };
                        });
                    } else {
                        return null;
                    }
                })
                .catch(console.error)
                .finally((_) => {
                    this.motivoDespesaLoading = false;
                });
        },
        onCleanFilters() {
            this.situacaoSelected = [];
            this.areaSelected = { label: "todos", id: -1 };
            this.empresaSelected = [];
            this.colaboradorSelected = [];
            this.motivoDespesaSelected = [];
            this.limparBusca = true;
            this.filtros.search = "";
            this.datainicial = (() => {
                let trintaDiasAtras = new Date();
                trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 31);
                return trintaDiasAtras;
            })();
            this.datafinal = new Date();
            this.timeoutCarregarDados();
        },
        timeoutCarregarDados(time = 600) {
            this.showFiltros = false;
            setTimeout(() => {
                this.carregarDados();
                this.limparBusca = false;
            }, time);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date) {
            this.datainicial = date;
            this.carregarDados();
        },
        changeEndDate(date) {
            this.datafinal = date;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;

            this.atualizaFiltros();

            this.service
                .findAll(currentPage - 1, this.pagination.perPage, this.filtros)
                .then(this.mapItems)
                .then((value) => {
                    this.adiantamentos = value;
                    this.isEmpty = this.adiantamentos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os adiantamentos.");
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });

            this.service
                .getTotalValor(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.filtros
                )
                .then((r) =>
                    r.content.map((item) => (this.valorAdiantamentos = item))
                );
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    iddespesa: m.iddespesa,
                    idadiantamento: m.idadiantamento,
                    colaborador: m.usuario.nome,
                    "motivo": m.descricaomotivo,
                    valor: m.valor,
                    situacao: m.situacao,
                    "data-lancamento": m.datahora,
                    isDespesa: m.isDespesa,
                    descricao: m.descricaogeral,
                };
            });
            return list;
        },
        promptForDelete(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t("msg-confirmacao-desativacao-adiantamento-n", 
                    { n: row.colaborador, v: this.getDecimal(row.valor, null, true) }
                ),
                onConfirm: () => this.promptForMotivoDelete(row),
                onCancel: this.removePrompt,
            });
        },
        promptForMotivoDelete(row) {
            this.$root.prompt({
                message: this.$t("msg-motivo-desativacao-adiantamento-n", 
                    { n: row.colaborador, v: his.getDecimal(row.valor, null, true) }
                ),
                confirmText: this.$t("confirmar"),
                onConfirm: this.deletarAdiantamento,
                cancelText: this.$t("cancelar"),
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deletarAdiantamento(motivo) {
            this.isLoading = true;
            this.service
                .deleteAdiantamentoById(this.delete.idadiantamento, motivo)
                .then((_) => {
                    this.$root.showMessage(
                        "success",
                        "msg-adiantamento-success-desativar"
                    );
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error("Erro ao remover acerto.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-problema-realizar-acao"
                    );
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        isStatusButtonType(status) {
            if (status == "ABERTO") return "is-warning";
            else if (status == "FECHADO") return "is-success";
            else if (status == "APROVADO") return "is-success";
            else if (status == "AGUARDANDO-APROVACAO") return "is-warning";
            else if (status == "EM-CRIACAO") return "is-warning";
            else if (status == "REPROVADO") return "is-danger";
            else if (status == "EXCLUIDO") return "is-danger";
        },
        parseValueSearch(text) {
            //Função para deixar o valor no formato correto para api
            text = text.replace(".", "");
            text = text.replace(/[\,]+/g, ".");
            return text;
        },
        onSearch(text) {
            text = this.parseValueSearch(text);
            this.filtros.search = this.removeAcentos(text);
            this.carregarDados();
        },
        sortTable(field, order) {
            this.filtros.sort = field;
            this.filtros.order = order;
            this.carregarDados();
        },
        getTotalValue() {
            this.valorAdiantamentos = 0;
            this.adiantamentos.forEach((adiantamento) => {
                this.valorAdiantamentos += adiantamento.valor;
            });
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        getLocale(l) {
            return getLocale(l);
        },
        showLancamento(id, isDespesa) {
            this.isShowingLancamento = !this.isShowingLancamento;
            this.idLancamento = id;
            this.isDespesa = isDespesa;
        },
        /*
            @87842 - forma temporaria ate ser criada uma tela 
            separada para prestacao de contas
        */
        changeSituacao(area) {

            const situacaoMap = {
                "-1": [],
                "0": [
                    { label: "em-criacao", id: 3 },
                    { label: "aguardando-aprovacao", id: 4 },
                    { label: "aprovado", id: 1 },
                    { label: "reprovado", id: 0 },
                    { label: "excluido", id: 5 }
                ],
                "1": [
                    { label: "aberto", id: 6 },
                    { label: "fechado", id: 7 }
                ],
            }

            this.situacaoSelect = situacaoMap[area.id] || [];
            this.situacaoSelected = [];

        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    min-height: 100%;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        min-height: 100%;
        height: inherit;
        .calendar-btn {
            padding: 0;
            width: 100px;
            height: 35px;
        }
        .datepicker input {
            height: 40px !important;
        }
        .mt-3 {
            margin-top: 5rem !important;
        }
        .rodape-table-info {
            height: 100%;
        }
        .margin-none {
            margin: 0 !important;
        }
        .nav.nav-tabs {
            margin-bottom: 0;
            margin-left: -20px;
            padding-left: 20px;
        }
        .table-tag-full-width {
            width: 100%;
        }
    }
    .mt-2-custom {
        margin-top: 1.5rem;
    }
    @media screen and (max-width: 640px) {
        .mt-2-custom {
            margin-top: 0;
        }
    }
}
.card-content {
    padding-top: 0px;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0.75rem;
    margin: 0px;
    .card-content-section {
        padding:0px;
        margin-top: 0.75rem;
        margin-bottom: 0px;
        margin-left: 0px;
        margin-right: 0px;
    }
    .card-content-top {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }
    .card-content-motivo {
        padding-top: 0.25rem;
        padding-bottom: 3rem;
    }
}
</style>